import store from '../store'
import find from 'lodash/find'
import {getQuestionPollForControl,fetchSetPollForControl} from '../actions/polls'
//,fetchSingleSetPoll,fetchSingleQuestionPoll


export function getPollForControl(control) {	//returns either independent poll or setPollPoll
	const state = store.getState()
	let poll=null

	if(control && control.currentPoll){
		if(state.pusherPoll && state.pusherPoll.poll && state.pusherPoll.poll.id===control.currentPoll){
			poll=state.pusherPoll.poll
		}else{
			poll= find(state.historyQuestionPolls, {'id':control.currentPoll}) || find(state.queueQuestionPolls, {'id':control.currentPoll})
		}

		if(!poll){
			return store.dispatch(getQuestionPollForControl(control.currentPoll))
		}	


	}
	else if(control && control.setPoll && control.setPollPoll){

		if(state.pusherPoll && state.pusherPoll.setPollId===control.setPoll && state.pusherPoll.setPollPoll.id===control.setPollPoll){
			poll=state.pusherPoll.setPollPoll
		}else{
			const setPoll= find(state.historySetPolls, {'id':control.setPoll}) || find(state.queueSetPolls, {'id':control.setPoll})
			if(setPoll){
				poll=find(setPoll.polls, {'id':control.setPollPoll})
			}
		}
	}

	return poll

}




export function getSetPollForControl(control) {
	const state = store.getState()

	let poll=null
	 if(control && control.setPoll){

		poll= find(state.historySetPolls, {'id':control.setPoll}) || find(state.queueSetPolls, {'id':control.setPoll})	

		if(!poll){
			return store.dispatch(fetchSetPollForControl(control.setPoll))
		}
	}

	return poll

}


	


// WEBPACK FOOTER //
// ./src/utils/getPollForControl.js